import { render, staticRenderFns } from "./LogOutadd.vue?vue&type=template&id=1fae7248&scoped=true&"
import script from "./LogOutadd.vue?vue&type=script&lang=js&"
export * from "./LogOutadd.vue?vue&type=script&lang=js&"
import style0 from "./LogOutadd.vue?vue&type=style&index=0&id=1fae7248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae7248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fae7248')) {
      api.createRecord('1fae7248', component.options)
    } else {
      api.reload('1fae7248', component.options)
    }
    module.hot.accept("./LogOutadd.vue?vue&type=template&id=1fae7248&scoped=true&", function () {
      api.rerender('1fae7248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/LogOut/LogOutadd.vue"
export default component.exports